<template>
  <UsdgBottomCta v-if="variant === 'usdg'">
    <UsdgCtaButton
      size="big"
      custom-class="tw:w-full tw:bg-usdg-gradient-brand"
      :disabled="disabled"
      :is-loading="isLoading"
      @click="$emit('click')"
    >
      총 {{ comma(finalPrice) }}원 결제하기
    </UsdgCtaButton>
  </UsdgBottomCta>

  <div
    v-else
    class="fixed-btn-wrap"
  >
    <button
      type="button"
      class="btn-payment"
      :class="isLoading ? 'is-loading' : ''"
      :disabled="disabled || isLoading"
      @click="$emit('click')"
    >
      <span
        v-if="!isLoading"
        class="flex flex-justify-center flex-align-center"
      >
        <span>총 {{ comma(finalPrice) }}원 결제하기</span>
      </span>
      <span
        v-else-if="isLoading"
        class="flex flex-justify-center flex-align-center"
      >
        <i-outline-spin
          v-if="isLoading"
          filled
          class="spinner"
        />
        <span>결제 처리중...</span>
      </span>
    </button>
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    disabled: boolean
    finalPrice: number
    isLoading?: boolean
    variant?: 'legacy' | 'usdg'
  }>(),
  {
    variant: 'legacy'
  }
)
const { comma } = useUi()

const $emit = defineEmits(['click'])
</script>

<style scoped lang="scss">
$btnHeight: 56px;

.fixed-btn-wrap {
  position: fixed;
  bottom: 0;
  left: 50%;
  width: 100%;
  max-width: 500px;
  padding: 12px 16px; //12px 16px calc(env(safe-area-inset-bottom) + 12px);
  background-color: #fff;
  z-index: 1000;
  transform: translateX(-50%);

  .btn-payment {
    padding: 0 20px;
    width: 100%;
    height: $btnHeight;
    font-size: 16px;
    font-weight: 600;
    color: $base-white;
    background-color: $brand-point;
    border-radius: 8px;
    border: none;
    cursor: pointer;

    &:disabled {
      background-color: $gray-300;
      cursor: not-allowed;
    }
    &.is-loading {
      background-color: $button-primary-disable;
      cursor: not-allowed;
    }

    .spinner {
      margin-right: 8px;
      width: 20px;
      height: 20px;
      animation: spinner 1s linear infinite;
    }
    @keyframes spinner {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  }
}
</style>
